import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { LeadsService } from "../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-customers-birthday",
  templateUrl: "./customers-birthday.component.html",
  styleUrls: ["./customers-birthday.component.css"],
})
export class CustomersBirthdayComponent implements OnInit {
  customers: any;

  userData: any = JSON.parse(window.localStorage.getItem("userProfile")) || {};
  constructor(
    private errorHandlerService: ErrorHandlerService,
    private slimLoadingService: SlimLoadingBarService,
    private leadsService: LeadsService
  ) {}

  ngOnInit() {
    this.getCustomers();
  }

  getCustomers() {
    this.slimLoadingService.start();
    this.leadsService.getCustomersBirthday().subscribe(
      (res: any) => {
        this.customers = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/customers-birthday/customers-birthday.component.ts